import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import type { PIIString } from '@trello/privacy';
import { useLazyComponent } from '@trello/use-lazy-component';

import { Null } from 'app/src/components/Null';

export const LazyShareTemplatePopover: FunctionComponent<{
  name?: string;
  orgName?: string;
  enterpriseName?: string;
  url?: string;
  storyPageUrl?: string;
  visibility?: string;
  boardId?: string;
  teamId?: string;
  username?: PIIString;
}> = ({
  name = '',
  orgName,
  enterpriseName,
  url = '',
  storyPageUrl,
  visibility = '',
  boardId = '',
  teamId = '',
  username,
}) => {
  const ShareTemplatePopover = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "share-template-popover" */ './ShareTemplatePopover'
      ),
    { namedImport: 'ShareTemplatePopover' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Share Template Popover',
      }}
      errorHandlerComponent={Null}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <ShareTemplatePopover
            name={name}
            orgName={orgName}
            enterpriseName={enterpriseName}
            url={url}
            storyPageUrl={storyPageUrl}
            visibility={visibility}
            boardId={boardId}
            teamId={teamId}
            username={username}
          />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
